import { gsap } from 'gsap/all';

const getMousePos = (e) => {
    let posx = 0;
    let posy = 0;
    if (!e) e = window.event;
    if (e.pageX || e.pageY) {
        posx = e.pageX;
        posy = e.pageY;
    }
    else if (e.clientX || e.clientY) 	{
        posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
        posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }
    return { x : posx, y : posy }
}

// Hover effect
export default class HoverImgFx1 {
    constructor(el) {
        this.DOM = {el: el};
        this.DOM.reveal = document.createElement('div');
        this.DOM.reveal.className = 'hover-reveal';
        this.DOM.reveal.innerHTML = `<div class="hover-reveal__inner"><div class="hover-reveal__img" style="background-image:url(${this.DOM.el.dataset.img})"></div></div>`;
        this.DOM.el.appendChild(this.DOM.reveal);
        this.DOM.revealInner = this.DOM.reveal.querySelector('.hover-reveal__inner');
        this.DOM.revealInner.style.overflow = 'hidden';
        this.DOM.revealImg = this.DOM.revealInner.querySelector('.hover-reveal__img');
        this.DOM.revealParent = this.DOM.el;
        this.initEvents();
    }
    initEvents() {
        this.positionElement = (ev) => {
            const windowW = window.innerWidth;
            const documentH = document.body.scrollHeight;
            const mousePos = getMousePos(ev);
            const revealW = this.DOM.reveal.offsetWidth;
            const revealH = this.DOM.reveal.offsetHeight;
            const revealParentT = this.DOM.revealParent.offsetTop;
            const maxW = mousePos.x + revealW + 30;
            const maxPos = windowW - revealW - 80;
            const maxH = revealParentT + revealH + 100;
            // set top and left positions
            // this.DOM.reveal.style.top = `-${windowH - revealH/2}px`;
            
            if (maxW < windowW) {
                this.DOM.reveal.style.left = `${mousePos.x+20}px`;
            }else{
                this.DOM.reveal.style.left = `${maxPos}px`;
            }
            if (maxH < documentH) {
                this.DOM.reveal.style.top = '-30px';
            }else{
                this.DOM.reveal.style.top = `-${revealH-80}px`;
            }

            // console.log('Document height: ' + documentH);
            // console.log('This Top: ' + revealParentT);
            // console.log('Mouse ypos: ' + mousePos.y);
            // console.log('Reveal height: ' + revealH);
            // console.log('Mouse xpos: ' + mousePos.x);
            // console.log('Reveal width: ' + revealW);
            // console.log('Max width: ' + maxW);
            // console.log('Max pos: ' + maxPos);
        };
        this.mouseenterFn = (ev) => {
            this.positionElement(ev);
            this.showImage();
        };
        this.mousemoveFn = ev => requestAnimationFrame(() => {
            this.positionElement(ev);
        });
        this.mouseleaveFn = () => {
            this.hideImage();
        };
        this.DOM.el.addEventListener('mouseenter', this.mouseenterFn);
        this.DOM.el.addEventListener('mousemove', this.mousemoveFn);
        this.DOM.el.addEventListener('mouseleave', this.mouseleaveFn);
    }
    showImage() {
        gsap.killTweensOf(this.DOM.revealInner);
        gsap.killTweensOf(this.DOM.revealImg);
        this.tl = gsap.timeline({
            onStart: () => {
                this.DOM.reveal.style.opacity = 1;
                gsap.set(this.DOM.el, {zIndex: 1000});
            }
        })
        .to(this.DOM.revealImg, 0.4, {
            ease: 'expo.inOut',
            startAt: {opacity: '1'},
            opacity: '1'
        }, 0);
        // .to(this.DOM.revealInner, 0.4, {
        //     ease: 'expo.inOut',
        //     startAt: {x: '0%', y: '0%'},
        //     x: '0%',
        //     y: '0%'
        // })
        // .to(this.DOM.revealImg, 0.4, {
        //     ease: 'expo.inOut',
        //     startAt: {x: '0%', y: '0%'},
        //     x: '0%',
        //     y: '0%'
        // }, 0);
    }
    hideImage() {
        gsap.killTweensOf(this.DOM.revealInner);
        gsap.killTweensOf(this.DOM.revealImg);
        this.tl = gsap.timeline({
            onStart: () => {
                gsap.set(this.DOM.el, {zIndex: 999});
            },
            onComplete: () => {
                gsap.set(this.DOM.el, {zIndex: ''});
                gsap.set(this.DOM.reveal, {opacity: 0});
            }
        });
    }
}